import { Route, Routes } from 'react-router-dom';
import EmailNotifications from './components/EmailNotifications';
import UserPermissionsContainer from './container/UserPermissionsContainer';
import AdminPermissionState from './context/AdminPermissionState';
import { Breadcrumbs, Breadcrumb } from '@digitools/honest-react';
import { useHomePageBreadcrumbs } from 'src/components/Breadcrumbs';
const AdminRouter = () => {
    const breadCrumbTitle = () => {
        if (window.location.pathname.includes('/emailNotification')) {
            return 'E-mail Settings';
        }
        else if (window.location.pathname.includes('/permissions')) {
            return 'User Access';
        }
    };
    return (<>
      <Breadcrumbs>
        {useHomePageBreadcrumbs()}
        <Breadcrumb>{breadCrumbTitle()}</Breadcrumb>
      </Breadcrumbs>
      <AdminPermissionState>
        <Routes>
          <Route path={`/emailNotification`} element={<EmailNotifications />}/>
          <Route path={`/permissions`} element={<UserPermissionsContainer />}/>
        </Routes>
      </AdminPermissionState>
    </>);
};
export default AdminRouter;
